import React, { Component } from 'react';
import { Text, View, ScrollView, Platform, Image, Pressable, StyleSheet } from 'react-native';

import OPComponent from '../components/op_component';
import { COLOR, FONT, FONT_SIZE } from '../../constants/styles';

class GiftButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Pressable onPress={this.props.onPress} style={styles.giftButton}>
        <Image
          style={styles.giftButtonImage}
          source={this.props.imageSource}
          resizeMode="contain"
        />
      </Pressable>
    );
  }
}

export default class GiftTool extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { onSelect, gifts } = this.props;
    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.headerText}>Send Your Thoughts</Text>
          <Pressable onPress={this.props.onClose} style={styles.closeButton}>
            <Image
              style={styles.closeButtonImage}
              source={require('../../../resources/close-orange.png')}
              resizeMode="contain"
            />
          </Pressable>
        </View>
        <View style={styles.buttonsContainer}>
          <ScrollView contentContainerStyle={styles.scrollViewContent} horizontal={true}>
            {Object.keys(gifts).map((giftText) => (
              <GiftButton
                key={giftText}
                imageSource={gifts[giftText]}
                onPress={() => onSelect(giftText)}
              />
            ))}
          </ScrollView>
        </View>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  container: {},
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.accent,
    height: 60,
    borderColor: COLOR.altAccent,
    borderBottomWidth: 1,
  },
  headerText: {
    flex: 1,
    ...FONT.medium,
    fontSize: FONT_SIZE.xlarge,
    color: COLOR.text,
    marginLeft: 25,
  },
  closeButton: {
    height: 60,
    width: 60,
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeButtonImage: {
    width: 22,
    height: 22,
  },
  buttonsContainer: {
    backgroundColor: COLOR.altContrast,
    height: 130,
  },
  scrollViewContent: {
    paddingHorizontal: 10,
    paddingVertical: 23,
  },
  giftButton: {
    height: 82,
    width: 82,
    borderRadius: 41,
    marginHorizontal: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLOR.contrast,
    borderColor: COLOR.accent,
    borderWidth: Platform.OS == 'ios' ? 1 : 0,
    shadowOpacity: 0.1,
    shadowRadius: 3,
    shadowColor: COLOR.shadow,
    shadowOffset: { height: 0, width: 0 },
    elevation: 2,
  },
  giftButtonImage: {
    width: 44,
    height: 46,
  },
});
